module.exports = __webpack_public_path__ + "img/wf-finishing-position-25.c59d51c2.svg";